/*
* 仓库费用配置
* */
export const GETWAREHOUSECOST = 'GETWAREHOUSECOST'
export const WAREHOUSECOSTADD = 'WAREHOUSECOSTADD'
export const WAREHOUSECOSTEDIT = 'WAREHOUSECOSTEDIT'
export const WAREHOUSECOSTUPDATECOST = 'WAREHOUSECOSTUPDATECOST'
export const WAREHOUSECOSTDEL = 'WAREHOUSECOSTDEL'

export const GETCHILDS = 'GETCHILDS'
export const GETWAREHOUSECOSTSAVE = 'GETWAREHOUSECOSTSAVE'
export const GETCHARGETYPE = 'GETCHARGETYPE'
export const GETCOSTPROJECT = 'GETCOSTPROJECT'
export const YCDISPATCHPLATFORMPOINT = 'YCDISPATCHPLATFORMPOINT'
// export const GETCHARGING = 'GETCHARGING'

export const GENERALCONFIG = 'GENERALCONFIG'
export const GETGENERALCONFIG = 'GETGENERALCONFIG'



// WEBPACK FOOTER //
// ./src/store/costConfigure/types.js